import { connect, useDispatch } from 'react-redux';
import { change, reset, submit } from 'redux-form';
import PatientForm from '../../../components/authorised/patient/account/PatientForm'
import { patientCreate, patientsLoad, patientUpdate } from '../../../redux/actions/patient/patientActions';
import SaveButton from '../../../itrust_common/components/others/SaveButton'
import ScrollToTarget from '../../../itrust_common/components/others/ScrollToTarget';
import _ from 'lodash';
import SecondaryPatientForm from '../../../components/authorised/patient/account/SecondaryPatientForm';
import { useState } from 'react';
import { quickActions, quickActionsReset } from '../../../redux/actions/dashboard/quickActionActions';
import Alert from '../../../itrust_common/components/Alert';
import { useHistory } from 'react-router-dom';
import * as $ from 'jquery';

function AccountInformationPartial(props) {
  const { saving, patient, isWizard, isFullMode, isQuickAction, setWizardTab, storeSpecificPatients, currentStoreId, filters, quickAction, accountInfoWidth } = props;
  const [activeTab, setActiveTab] = useState('personal-info')
  const [currentForm, setCurrentForm] = useState(isQuickAction ? 'secondaryPatientForm' : 'patientForm')
  const dispatch = useDispatch()
  const history = useHistory()

  const handlePatientSubmit = async (data) => {
    if (isWizard) {
      await dispatch(patientUpdate(data, { include: "*" }))
      data.patient_insurance_update && dispatch(change(currentForm, `patient_insurance_update`, false)); // reset insurance update flag after submit
      setWizardTab(2)
    }
    else {
      let res = {};
      if (data.id && data.id !== 'New') {
        res = await dispatch(patientUpdate(data, { include: "*" }))
        data.patient_insurance_update && dispatch(change(currentForm, `patient_insurance_update`, false)); // reset insurance update flag after submit
      }
      else {
        if (storeSpecificPatients) {
          data = { ...data, store_ids: [currentStoreId] }
        }
        dispatch(patientCreate(data, { include: "*" })).then((response) => {
          res = response
          handleSetQuickActionPatient(res)
        }).catch(error => {
          if (error.response.data.error == "Patient already exists.") {
            handlePatientAlreadyExist(error.response.data)
          }
        })
      }
    }
  }

  const handleSetQuickActionPatient = (res) => {
    res = res?.value?.data?.patient
    if (res.id && currentForm == 'secondaryPatientForm') {
      history.push(`/patients/${res?.id}/account_information`)
      $('#fullModePatient-modal').modal('hide')
      $('#quickActionPatientForm-modal').modal('hide');
      dispatch(quickActions({ select_patient_modal: false }))
      dispatch(quickActionsReset())
      dispatch(reset('secondaryPatientForm'))
    }
  }

  const handlePatientAlreadyExist = (resObj) => {
    const filter = {
      sort: filters.sort || 'created_at',
      direction: filters.direction || 'desc',
      search: filters.search || '',
      filter: filters.filter || {},
      page: filters.page || 1,
      rpp: filters.rpp || 10,
      include: ["patient_vision_insurance", "patient_medical_insurance"],
      fields: ['id', 'first_name', 'last_name', 'name', 'date_of_birth', 'email', 'cell_phone', 'occupation', 'recall_reminder_date', 'avatar_attributes']
    }
    Alert.confirm('Patient already exists. Click Continue to add to this store.', (resOk) => {
      if (resOk) {
        dispatch(patientUpdate({ ...resObj.patient, store_ids: [...resObj.patient.store_ids, currentStoreId] }))
          .then((res) => {
            res = res.value.data.patient
            if (window.location.pathname == '/patients') {
              dispatch(patientsLoad(filter))
            }
            if (quickAction.select_patient_modal == 'patient') {
              // Quick Action
              dispatch(quickActions({ patient: res }))
            }
          })
      }
    })
  }

  const handleRemoteSubmit = () => {
    dispatch(submit(currentForm))
  }

  const handleTabs = (tab, form) => {
    if (tab == "password") {
      handleRemoteSubmit()
    }
    setTimeout(function () {
      setActiveTab(tab)
      setCurrentForm(form)
      ScrollToTarget(tab)
    }, 500)
  }

  const isTabActive = (tab) => {
    if (activeTab === tab)
      return 'text-primary'
    else
      return 'text-muted';
  }

  return (
    <div>
      <div className={`d-none d-lg-block position-fixed ${isWizard ? 'patient-profile-nav' : isFullMode ? 'patient-form-sections-appointment' : 'patient-form-sections-profile'}`}>
        <ul className="list-unstyled border border-light shadow-sm bg-white">
          <li className="py-5 pl-7 pr-9 border-bottom border-light border-bottom-2">
            <a href="javascript:void(0)" className={isTabActive('patient-personal-tab')} onClick={() => handleTabs('patient-personal-tab', 'patientForm')}> Personal Information </a>
          </li>
          <li className="py-5 pl-7 pr-9 border-bottom border-light border-bottom-2">
            <a href="javascript:void(0)" className={isTabActive('patient-address-tab')} onClick={() => handleTabs('patient-address-tab', 'patientForm')}> Address </a>
          </li>
          <li className="py-5 pl-7 pr-9 border-bottom border-light border-bottom-2">
            <a href="javascript:void(0)" className={isTabActive('patient-primary-insurance-tab')} onClick={() => handleTabs('patient-primary-insurance-tab', 'patientForm')}> Insurance Detail </a>
          </li>
          <li className="py-5 pl-7 pr-9 border-bottom border-light border-bottom-2">
            <a href="javascript:void(0)" className={isTabActive('patient-primary-physician-tab')} onClick={() => handleTabs('patient-primary-physician-tab', 'patientForm')}> Primary Physician </a>
          </li>
          <li className="py-5 pl-7 pr-9 border-bottom border-light border-bottom-2">
            <a href="javascript:void(0)" className={isTabActive('patient-term-of-service-tab')} onClick={() => handleTabs('patient-term-of-service-tab', 'patientForm')}> Terms of Service </a>
          </li>
        </ul>
        {!isWizard && <SaveButton saving={saving} label="Save changes" handleOnClick={handleRemoteSubmit} />}
      </div>

      <div className="d-lg-none patient-form-sections-mobile mb-5">
        <ul className="list-unstyled d-flex flex-nowrap overflow-auto hidden-scroll border border-light shadow-sm bg-white mb-0">
          <li className="py-4 px-5 border-right border-light text-nowrap">
            <a href="javascript:void(0)" className={isTabActive('patient-personal-tab')} onClick={() => handleTabs('patient-personal-tab', 'patientForm')}>Personal Information</a>
          </li>
          <li className="py-4 px-5 border-right border-light text-nowrap">
            <a href="javascript:void(0)" className={isTabActive('patient-address-tab')} onClick={() => handleTabs('patient-address-tab', 'patientForm')}>Address</a>
          </li>
          <li className="py-4 px-5 border-right border-light text-nowrap">
            <a href="javascript:void(0)" className={isTabActive('patient-primary-insurance-tab')} onClick={() => handleTabs('patient-primary-insurance-tab', 'patientForm')}>Insurance Detail</a>
          </li>
          <li className="py-4 px-5 border-right border-light text-nowrap">
            <a href="javascript:void(0)" className={isTabActive('patient-primary-physician-tab')} onClick={() => handleTabs('patient-primary-physician-tab', 'patientForm')}>Primary Physician</a>
          </li>
          <li className="py-4 px-5 border-right border-light text-nowrap">
            <a href="javascript:void(0)" className={isTabActive('patient-term-of-service-tab')} onClick={() => handleTabs('patient-term-of-service-tab', 'patientForm')}>Terms of Service</a>
          </li>
        </ul>
      </div>

      <div className="patient-from-fields patient-from-fields-mobile-save">
        <div className="row">
          <div className={`${isQuickAction ? 'col-11' : 'col-lg-8 col-12'}`}>
            <div className="row">
              <div className="col-12">
                <div className={currentForm === 'passwordForm' && 'd-none'}>
                  {isQuickAction ?
                    <SecondaryPatientForm
                      onSubmit={handlePatientSubmit}
                      isLongForm={true}
                    /> :
                    <>
                      {!_.isEmpty(patient) && <PatientForm
                        onSubmit={handlePatientSubmit}
                        isLongForm={true}
                      />}
                    </>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {!isWizard && (
        <div className="d-lg-none patient-save-sticky-footer">
          <SaveButton saving={saving} label="Save changes" handleOnClick={handleRemoteSubmit} />
        </div>
      )}

    </div>
  )
}


const mapStateToProps = state => {
  const { patient, appointment, organisation: { organisation }, currentStore, filter, dashboard: { quickAction } } = state;
  return {
    patient: patient.patient,
    saving: patient.saving,
    isFullMode: appointment.handlerData?.isFullMode,
    storeSpecificPatients: organisation.preferences?.store_specific_patients,
    currentStoreId: currentStore.store.id,
    filters: filter.filters,
    quickAction,
  }
}
export default connect(mapStateToProps)(AccountInformationPartial);